import type { RiskIndexSource } from '@app/src/types/resourceExplorer'
import type { IntlShape } from 'react-intl'

// Indices built by Worldfavor have no external website, so their sourceLink is left out of en.json.
export const getRiskIndexSourceLink = (
  source: RiskIndexSource,
  messages: IntlShape['messages'],
): string | undefined => {
  const link = messages[`schemas.risk.riskIndexes.${source}.sourceLink`]
  return typeof link === 'string' ? link : undefined
}
